import React, { useContext } from 'react';

import { ModalDialogType } from '../ModalDialogTypes';

const ModalDialogTypeContext = React.createContext<undefined | ModalDialogType>(undefined);

export const useModalDialogTypeContext = () => useContext(ModalDialogTypeContext);

export default ModalDialogTypeContext;
